import { Component, Vue } from "vue-property-decorator";

@Component
export default class RemoteConnectionConfig extends Vue {
  render() {
    return <div>123</div>;
  }
}
